import { NavLink } from 'react-router-dom'

import styles from './AppShell.module.css'

interface NavItem {
  readonly to: string
  readonly label: string
  readonly path: string
}

/**
 * Five destinations, which is the most a bottom bar can hold at a comfortable
 * touch target on a 375px viewport. Track and template management live under
 * Settings rather than competing for a slot: they are set up occasionally,
 * while logging happens several times a day.
 */
const ITEMS: readonly NavItem[] = [
  { to: '/', label: 'Home', path: 'M4 10.5 12 4l8 6.5V20h-6v-5h-4v5H4z' },
  { to: '/log', label: 'Log', path: 'M12 5v14M5 12h14' },
  { to: '/timeline', label: 'Timeline', path: 'M4 7h16M4 12h16M4 17h10' },
  { to: '/insights', label: 'Insights', path: 'M4 19V5m0 14h16M8 15l4-5 3 3 4-6' },
  {
    to: '/settings',
    label: 'Settings',
    path: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM4 12h2m12 0h2M12 4v2m0 12v2',
  },
]

export function Navigation() {
  return (
    <nav className={styles['nav']} aria-label="Main">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          // `end` only on "/", or the home link stays active on every route,
          // since every path starts with a slash.
          end={item.to === '/'}
          className={({ isActive }) =>
            `${styles['navLink']} ${isActive ? styles['navLinkActive'] : ''}`
          }
          // NavLink sets `aria-current="page"` on the active link itself, which
          // is what carries the current-page state to a screen reader. The
          // colour and weight below are the sighted half of the same signal —
          // neither is sufficient alone.
        >
          <svg
            className={styles['navIcon']}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="square"
            strokeLinejoin="miter"
            aria-hidden="true"
          >
            <path d={item.path} />
          </svg>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
